import request from "@/hooks/useRequest";

// 获取提交信息
export const getCompanyInfoApi = () => {
  return request("/web-wallet/api/v1/kyc/company");
};
